export * from '../../common/store/mutations';

// Configs service
export const SET_ORDER_FORM_CONFIG = 'setOrderFormConfig';

// ChoiceList model
export const SET_CHOICE_LIST = 'setChoiceList';
export const SET_PREVIOUS_CHOICE_LIST = 'setPreviousChoiceList';

// Payments
export const SET_RECURRENCE = 'setRecurrence';

// Products
export const SET_CONTRACTED_PRODUCTS = 'setContractedProducts';



// WEBPACK FOOTER //
// ./src/multiple/store/mutations.js